export default __webpack_public_path__ + "static/media/magicsnacks@2x.4a28d09f.jpg";